module.exports = {"env":"production","Web":{"resource_domain":"http://media-dlc.sce.pccu.edu.tw/deep"},"serieses_data_path":"/var/www/deep-portal/series-data","iPostJsonApi":"http://localhost:28006/api","SeriesData":"https://deep.pccu.edu.tw/series-data/","Secret":"J*.HDU2o6{C'sBi*Y=s#","JsonEditorPassword":"c0603ddc91f1cbdff912b8a3c4b084c51335b2f81d814df5c8ae90e15b6f02caf557e378517ad796c41f4e15061c1dcbb52c0e804bf9c5d36d82c662f9774140"}


//////////////////
// WEBPACK FOOTER
// ./src/config/prod.json
// module id = ojgt
// module chunks = 0